import {IControllers, Loader} from "../loader";
import {IController} from "../controller";

export class UsuarioLoader extends Loader {
    /* STATIC */
    public static override async build(): Promise<IControllers> {
        const onload: IController[] = [];
        if (window.location.pathname.includes("/usuario/")) {
            const [
                {UsuarioController},
            ] = await Promise.all([
                import(/* webpackChunkName: "encuesta" */ `../controllers/usuario`),
            ]);

            onload.push(...[
                UsuarioController,
            ])
        }
        return {
            ...await super.build(),
            onload,
        };
    }

    /* INSTANCE */
}
